import Link from "next/link";
import { useRouter } from "next/router";
import { BreadcrumbJsonLd } from "next-seo";
import useTranslation from "next-translate/useTranslation";

const TRAILING_SLASH_REGEX = /\/$/;

interface IBreadrumbs {
  product?: string;
  // type: string;
}

export const Breadcrumb: React.FC<IBreadrumbs> = ({ product }) => {
  const router = useRouter();
  const { t, lang } = useTranslation("common");
  const paths = router.asPath.split("/");

  const link = (segments: string[], size: number) => {
    const href = segments
      .slice(0, size + 1)
      .map((item) => `${item}`)
      .join("/");
    return href.toString().replace(TRAILING_SLASH_REGEX, "");
  };

  const isProduct = product === undefined ? 1 : 2;

  const domain = ($lang: string) => {
    switch ($lang) {
      case "pl":
        return "https://knsokna.pl";
      case "de":
        return "https://knsfenster.de";
      case "cs":
        return "https://kns-okna.eu";
      case "it":
        return "https://knsfinestre.it";
      case "fr":
        return "https://knsfenetres.fr";
      case "hu":
        return "https://knsokna.eu";
      case "en":
        return "https://knswindows.com";
      default:
        return "https://knswindows.com";
    }
  };

  return (
    <nav aria-label="Breadcrumb" className="my-2 flex">
      <BreadcrumbJsonLd
        items={
          [
            {
              item: `${domain(lang)}/`,
              name: t("home.title"),
            },
            paths.length > 1 && {
              item: `${domain(lang)}/${paths[1]}`,
              name: t(`${paths[1]}.title`),
            },
            paths.length > 2 && {
              item: `${domain(lang)}/${paths[1]}/${paths[2]}`,
              name: isProduct === 2 ? product : t(`${paths[1]}.${paths[2]}`),
            },
            paths.length > 3 && {
              item: `${domain(lang)}/${paths[1]}/${paths[2]}/${paths[3]}`,
              name: isProduct === 2 ? product : t(`${paths[3]}`),
            },
            paths.length > 4 && {
              item: `${domain(lang)}/${paths[1]}/${paths[2]}/${paths[3]}/${
                paths[4]
              }`,
              name: isProduct === 2 ? product : t(`${paths[4]}.title`),
            },
          ].filter(Boolean) as { name: string; item?: string }[]
        }
      />
      <ol className="inline-flex items-center space-x-1">
        <li className="inline-flex items-center">
          <a
            className="inline-flex items-center font-medium text-gray-700 text-sm hover:text-gray-900 dark:text-gray-400 dark:hover:text-black"
            href={lang === "en" ? "/" : `/${lang}`}
          >
            <svg
              className="h-4 w-4"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Home</title>
              <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
            </svg>
          </a>
        </li>
        {Array.from({ length: paths.length - isProduct }).map((_, i) => (
          <li key={link(paths, i + 1)}>
            <div className="flex items-center">
              <svg
                className="h-6 w-6 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>Arrow right</title>
                <path
                  clipRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  fillRule="evenodd"
                />
              </svg>
              <Link
                className="ml-1 font-medium text-gray-700 text-sm hover:text-gray-900 md:ml-2 dark:text-gray-400 dark:hover:text-black"
                href={link(paths, i + 1)}
                prefetch={false}
              >
                {i === 0 && t(`${paths[i + 1]}.title`)}
                {i === 1 && t(`${paths[i]}.${paths[i + 1]}`)}
                {i === 2 && t(`${paths[i + 1]}`)}
                {/* {paths[i + 1]} */}
              </Link>
            </div>
          </li>
        ))}
        {isProduct === 2 && (
          <li key={router.asPath}>
            <div className="flex items-center">
              <svg
                className="h-6 w-6 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>Arrow right</title>
                <path
                  clipRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  fillRule="evenodd"
                />
              </svg>
              {/* <Link
                href={link(paths, paths.length + 1)}
                className="ml-1 text-sm font-medium text-gray-700 hover:text-gray-900 md:ml-2 dark:text-gray-400 dark:hover:text-black"
              > */}
              {product}
              {/* </Link> */}
            </div>
          </li>
        )}
      </ol>
    </nav>
  );
};
